// Tag for graphql format
const gql = String.raw;

// Commons Fragments
import {
	BonusDefinitionFragment,
	CallActivityPerformanceFragment,
	CommissionTiersFragment,
	CustomerSatisfactionStoreFragment,
	MetricFragment,
	LongevityFragment,
	UserFullNameFragment,
	InputValueFragment,
} from "@PayPlans/api/fragments/commons";

// Additional Fragments
import { GrossDepartmentalFragment, OperatingCostsFragment } from "@PayPlans/api/fragments/managers/departmental";
import { SFEBonusFragment } from "@PayPlans/api/fragments/managers/sales";

export const onCreateServiceDepartmentalPayPlan = gql`
	subscription onCreateServiceDepartmentalPayPlan($locationId: String, $position: String) {
		onCreateServiceDepartmentalPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
			name
			position
			bodyShop {
				...GrossDepartmental
			}
			parts {
				...GrossDepartmental
			}
			service {
				...GrossDepartmental
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			customerSatisfaction {
				...CustomerSatisfactionStore
			}
			ebe {
				...SFEBonus
			}
			sfe {
				...SFEBonus
			}
			pase {
				...SFEBonus
			}
			longevity {
				...Longevity
			}
			operatingCosts {
				...OperatingCosts
			}
			locked
			available
			formatVersion
			createdAt
			createdBy {
				...UserFullName
			}
			updatedAt
			updatedBy {
				...UserFullName
			}
		}
	}
	${BonusDefinitionFragment}
	${GrossDepartmentalFragment}
	${CallActivityPerformanceFragment}
	${CommissionTiersFragment}
	${CustomerSatisfactionStoreFragment}
	${MetricFragment}
	${SFEBonusFragment}
	${LongevityFragment}
	${OperatingCostsFragment}
	${UserFullNameFragment}
	${InputValueFragment}
`;

export const onCloneServiceDepartmentalPayPlan = gql`
	subscription onCloneServiceDepartmentalPayPlan($locationId: String, $position: String) {
		onCloneServiceDepartmentalPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
			name
			position
			bodyShop {
				...GrossDepartmental
			}
			parts {
				...GrossDepartmental
			}
			service {
				...GrossDepartmental
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			customerSatisfaction {
				...CustomerSatisfactionStore
			}
			ebe {
				...SFEBonus
			}
			sfe {
				...SFEBonus
			}
			pase {
				...SFEBonus
			}
			longevity {
				...Longevity
			}
			operatingCosts {
				...OperatingCosts
			}
			locked
			available
			formatVersion
			createdAt
			createdBy {
				...UserFullName
			}
			updatedAt
			updatedBy {
				...UserFullName
			}
		}
	}
	${BonusDefinitionFragment}
	${GrossDepartmentalFragment}
	${CallActivityPerformanceFragment}
	${CommissionTiersFragment}
	${CustomerSatisfactionStoreFragment}
	${MetricFragment}
	${SFEBonusFragment}
	${LongevityFragment}
	${OperatingCostsFragment}
	${UserFullNameFragment}
	${InputValueFragment}
`;

export const onUpdateServiceDepartmentalAvailablePayPlan = gql`
	subscription onUpdateServiceDepartmentalAvailablePayPlan($locationId: String, $_id: String, $position: String) {
		onUpdateServiceDepartmentalAvailablePayPlan(locationId: $locationId, _id: $_id, position: $position) {
			_id
			available
			name
			position
		}
	}
`;

export const onDeleteServiceDepartmentalPayPlan = gql`
	subscription onDeleteServiceDepartmentalPayPlan($locationId: String, $position: String) {
		onDeleteServiceDepartmentalPayPlan(locationId: $locationId, position: $position) {
			_id
			locationId
		}
	}
`;

export const onUpdateServiceDepartmentalPayPlan = gql`
	subscription onUpdateServiceDepartmentalPayPlan($locationId: String, $_id: String, $position: String) {
		onUpdateServiceDepartmentalPayPlan(locationId: $locationId, _id: $_id, position: $position) {
			_id
			locationId
			name
			position
			bodyShop {
				...GrossDepartmental
			}
			parts {
				...GrossDepartmental
			}
			service {
				...GrossDepartmental
			}
			callActivityPerformance {
				...CallActivityPerformance
			}
			customerSatisfaction {
				...CustomerSatisfactionStore
			}
			ebe {
				...SFEBonus
			}
			sfe {
				...SFEBonus
			}
			pase {
				...SFEBonus
			}
			longevity {
				...Longevity
			}
			operatingCosts {
				...OperatingCosts
			}
			locked
			available
			formatVersion
			createdAt
			createdBy {
				...UserFullName
			}
			updatedAt
			updatedBy {
				...UserFullName
			}
		}
	}
	${BonusDefinitionFragment}
	${GrossDepartmentalFragment}
	${CallActivityPerformanceFragment}
	${CommissionTiersFragment}
	${CustomerSatisfactionStoreFragment}
	${MetricFragment}
	${SFEBonusFragment}
	${LongevityFragment}
	${OperatingCostsFragment}
	${UserFullNameFragment}
	${InputValueFragment}
`;
